import { object, string } from "yup";
import { firebaseDate } from "@poseidon/utils/yupSchemaTypes";

export const sailorRiskProfileSchema = object({
  kycAmlStatus: string().default(() => "pending"),
  pepStatus: string().default(() => "pending"),
  updatedAt: firebaseDate,
});
